import { useEffect, useState } from "react";
import Navbar from "../../components/layout/Navbar";
import Footer from "../../components/layout/Footer";
import { api } from "../../lib/api";
import { SurveyCard } from "./RespondentDashboard";

export default function SurveyList() {
    const [items, setItems] = useState([]);
    const [filter, setFilter] = useState("All");
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get("/surveys/available").then((r) => {
            setItems(r.data || []);
            setLoading(false);
        }).catch(() => setLoading(false));
    }, []);

    const cats = ["All", ...Array.from(new Set(items.map((i) => i.category))).filter(Boolean)];
    const visible = filter === "All" ? items : items.filter((i) => i.category === filter);

    return (
        <div className="bg-paper min-h-screen">
            <Navbar />
            <main className="max-w-7xl mx-auto px-6 lg:px-8 py-12">
                <p className="eyebrow mb-2">EARN</p>
                <h1 className="h2 mb-6" data-testid="survey-list-title">Surveys available to you</h1>
                <div className="flex flex-wrap gap-2 mb-8">
                    {cats.map((c) => (
                        <button
                            key={c}
                            onClick={() => setFilter(c)}
                            className={`btn ${filter === c ? "btn-ink" : "btn-outline"} text-sm py-2 px-4`}
                            data-testid={`filter-${c.toLowerCase().replace(/\s+/g, "-")}`}
                        >
                            {c}
                        </button>
                    ))}
                </div>
                {loading ? (
                    <div className="text-sm text-ink-600">Loading…</div>
                ) : visible.length === 0 ? (
                    <div className="card-base p-8 text-center text-sm text-ink-600">No surveys match your filter or profile.</div>
                ) : (
                    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
                        {visible.map((s) => <SurveyCard key={s.id} s={s} />)}
                    </div>
                )}
            </main>
            <Footer />
        </div>
    );
}
